import { useEffect, useState, useContext } from "react";
import LoadingSpinner from "../../base/loadingSpinner.js";
import UserContext from "../../../context/userContext.js";
import ErrorNotification from "../../base/errorNotification.js";
import { Button, Form, Row, Col, Card, Alert } from "react-bootstrap";
import SessionExpiredModal from "../../base/sessionExpiredModal.js";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import RadioField from "../../formFields/radioField.js";
import {
    getUserWaitingListResponse,
    createUserWaitingListResponse,
} from "../../../utils/sendRequest.js";
import * as FormValidator from "../../../validation/index.js";

import CustomFieldError from "../../formFields/customFieldError.js";

export default function WaitingList({ loginProcess }) {

    const [loading, setLoading] = useState(true);
    const [serverError, setServerError] = useState();
    const userDetail = useContext(UserContext);
    const [failed, setFailed] = useState(false);
    const [success, setSuccess] = useState(false);

    const navigate = useNavigate();

    const [sessionExpired, setSessionExpired] = useState(false);

    const closeModalNoRefresh = async () => {
        setSessionExpired(false);
    };
    useEffect(() => {
        async function getWaitingListStatus() {
            try {

                const res = await getUserWaitingListResponse(
                    userDetail.token,
                    userDetail.clientRequestId
                );

                //Only show the form if 3 = none,  no response
                if (res.campaignResponseId !== 3) {
                    setSuccess(true);
                }

                setLoading(false);
            } catch (err) {
                if (
                    (err.message && err.message.includes("Session has expired")) ||
                    (err.message && err.message.includes("Invalid token"))
                ) {
                    setSessionExpired(true);
                    setServerError(err);
                    setLoading(false);
                } else {
                    setServerError(err);
                    setLoading(false);
                }
            }
        }
        getWaitingListStatus();
    }, []);


    if (loading) {

        return (
            <Row>
                <Col xs={12} sm={12} md={8}>
                    <LoadingSpinner />
                </Col>
            </Row>
        );
    } else if (success) {

        return (
            <Row>

                <Col xs={12} sm={12} md={9}>
                    <Alert variant="success">
                        Waiting list response has been successfully submitted thank you. Please log out to end your session.
                    </Alert>
                </Col>
            </Row>
        )
    }

    else {
        if (serverError) {
            return (
                <>
                    {sessionExpired && (
                        <SessionExpiredModal
                            show={true}
                            onHide={() => {
                                navigate(0);
                                setSessionExpired(true);
                            }}
                            loginProcess={loginProcess}
                            closeModalNoRefresh={closeModalNoRefresh}
                        />
                    )}

                    <Row>

                        <Col xs={12} sm={12} md={9}>
                            <ErrorNotification alertMessage={serverError.message} />
                        </Col>
                    </Row>
                </>
            );
        } else {
            return (
                <Row>
                    <Col xs={12} sm={12} md={8}>
                        <Card>

                            {failed && (
                                <Card bg="danger" text="light" className="mb-3 mt-3">
                                    <Card.Header>Error</Card.Header>
                                    <Card.Body>
                                        {failed ? failed.message : "Error completing request"}
                                    </Card.Body>
                                </Card>
                            )}
                            <Card.Body>
                                <Formik
                                    initialValues={{
                                        campaignResponseTypeReferenceId: ""
                                    }}
                                    validationSchema={FormValidator.waitingList}
                                    onSubmit={async (values) => {
                                        setLoading(true);

                                        try {
                                            const res = await createUserWaitingListResponse(
                                                userDetail.token,
                                                userDetail.clientRequestId,
                                                values
                                            );
                                            setLoading(false);
                                            setSuccess(true);
                                            setServerError(null);
                                            setFailed(null);
                                        } catch (err) {


                                            if (
                                                (err.message && err.message.includes("Session has expired")) ||
                                                (err.message && err.message.includes("Invalid token"))
                                            ) {
                                                setSessionExpired(true);
                                                setFailed(err);
                                                setLoading(false);
                                            } else {
                                                setFailed(err);
                                                setLoading(false);
                                            }
                                        }
                                    }}
                                >
                                    {({ handleSubmit }) => {
                                        return (
                                            <Form noValidate onSubmit={handleSubmit} autoComplete="off">
                                                <h3 className="mb-4">Please let us know if you would like your child to stay on the Autism assessment waiting list</h3>
                                                <Form.Group controlId="campaignResponseTypeReferenceId" className="mb-2">
                                                    <RadioField
                                                        name="campaignResponseTypeReferenceId"
                                                        value="1"
                                                        label="Yes, I would like my child to stay on the waiting list for an Autism assessment"
                                                        type="radio"
                                                        disabled={loading}
                                                    />
                                                </Form.Group>
                                                <CustomFieldError name={'campaignResponseTypeReferenceId'} />


                                                <Button
                                                    type="submit"
                                                    variant="primary"
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <span>Submitting...</span>
                                                    ) : (
                                                        <span>Submit</span>
                                                    )}
                                                </Button>
                                            </Form>
                                        );
                                    }}
                                </Formik>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            );
        }
    }
}
